import OpenInvestmentCardsSection from "./OpenInvestmentCardsSection";

export default OpenInvestmentCardsSection;
